import React from "react";

export function BreakIcon() {
    return <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M14 0C12.8889 0 12 0.888889 12 2C12 3.11111 12.8889 4 14 4C15.1111 4 16 3.11111 16 2C16 0.888889 15.1111 0 14 0Z" fill="none"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M8 0C6.88889 0 6 0.888889 6 2C6 3.11111 6.88889 4 8 4C9.11111 4 10 3.11111 10 2C10 0.888889 9.11111 0 8 0Z" fill="none"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M2 0C0.888889 0 0 0.888889 0 2C0 3.11111 0.888889 4 2 4C3.11111 4 4 3.11111 4 2C4 0.888889 3.11111 0 2 0Z" fill="none"/>
    </svg>;
}
